// Module
var code = "<div class=\"fg-field-not-in-cache alert alert-error\"> <p> No template registered in cache for field type \"{{ field.schema.type }}\". </p> {{field}} </div> ";
// Exports
export default code;